<template>
  <div>
    <shipper-consignee-detail :data="data"> </shipper-consignee-detail>
    <div v-for="dangerousGood in dangerousGoods" v-bind:key="dangerousGood.id">
      <dangerous-goods :data="dangerousGood"></dangerous-goods>
    </div>
    <additional-information :data="data"></additional-information>
    <approve-certificate :data="data"></approve-certificate>
  </div>
</template>

<script>
import ShipperConsigneeDetail from "./ShipperConsigneeDetail";
import DangerousGoods from "./DangerousGoods";
import AdditionalInformation from "./AdditionalInformation";
import ApproveCertificate from "./ApproveCertificate";

export default {
  name: "MainDGDetails",
  components: {
    ShipperConsigneeDetail,
    DangerousGoods,
    AdditionalInformation,
    ApproveCertificate
  },
  props: {
    data: Object
  },

  computed: {
    dangerousGoods: function() {
      if (this.data !== null) {
        return this.data.dangerousGoods;
      }
    }
  }
};
</script>
<style scoped>
.single_dg {
  background-color: red;
  margin-top: 40px;
  margin-bottom: 40px;
  border-bottom: 2px dotted #ccc;
}
</style>
